import React, { useState, useEffect } from 'react'
import Header from '../../components/Header'
import { Box, Grid, GridItem, Text, Spinner, Alert, AlertIcon } from '@chakra-ui/react';
import { FiMessageSquare } from 'react-icons/fi'
import { BsCalendar, BsPlay } from 'react-icons/bs'
import {  } from "react-icons/io5";
import { FaCheck } from 'react-icons/fa'
import CampaignManagementTable from './Table/CampaignTable'
import { useNavigate } from 'react-router-dom'
import { fetchWrapper } from '../../helpers'
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper'


const Campaign = ({ header }) => {
    const navigate = useNavigate()
    const [summary, setSummary] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    // Load campaigns summary
    const loadSummary = async () => {
        try {
            setLoading(true)
            const url = `${process.env.REACT_APP_API_URL}/campaigns/analytics/summary`
            const response = await fetchWrapper.get(url)

            if (response.success) {
                setSummary(response.data)
            } else {
                throw new Error(response.message || 'Failed to load summary')
            }
        } catch (err) {
            console.error('Failed to load campaign summary', err)
            setError(err.message || 'Failed to load campaign summary')
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        loadSummary()
    }, [])

    function handleNewCampaign() {
        navigate("/campaign/add")
    }

    // Calculate summary stats
    const getSummaryStats = () => {
        if (!summary) return null

        const totalCampaigns = summary.total_campaigns || 0
        const statusCounts = {}
        let totalDelivered = 0
        let totalSent = 0

        if (summary.by_status) {
            summary.by_status.forEach(status => {
                statusCounts[status.status] = status.count
                totalDelivered += status.total_delivered || 0
                totalSent += status.total_sent || 0
            })
        }

        const deliveryRate = summary?.delivery_rate

        return {
            total: totalCampaigns,
            running: summary?.running_campaigns || 0,
            scheduled: summary?.scheduled_campaigns || 0,
            completed: summary?.completed_campaigns || 0,
            deliveryRate: `${deliveryRate}%`
        }
    }

    const stats = getSummaryStats()

    if (error) {
        return (
            <>
                <Header />
                <BoxWrapper p={8}>
                    <Alert status="error" borderRadius="md">
                        <AlertIcon />
                        Error loading campaign data: {error}
                    </Alert>
                </BoxWrapper>
            </>
        )
    }

    return (
        <>
            <Header header={header} />

            <BoxWrapper >


                {loading ? (
                    <Box textAlign="center" py={10}>
                        <Spinner size="xl" color="blue.500" />
                        <Text mt={4} color="gray.500">Loading campaign statistics...</Text>
                    </Box>
                ) : (
                    <Grid templateColumns='repeat(4, 1fr)' gap={6}>
                        <GridItem w='100%' >
                            <Box className='box-style-card'>
                                <Box p={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">
                                                Total Campaigns
                                            </Text>
                                            <Text fontSize="2xl" fontWeight="semibold">
                                                {stats?.total || 0}
                                            </Text>
                                        </Box>
                                        <FiMessageSquare style={{ fontSize: "1.5rem", color: "blue" }} />
                                    </Box>
                                </Box>
                            </Box>
                        </GridItem>

                        <GridItem w='100%' >
                            <Box className='box-style-card'>
                                <Box p={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">
                                                Running
                                            </Text>
                                            <Text fontSize="2xl" fontWeight="semibold">
                                                {stats?.running || 0}
                                            </Text>
                                        </Box>
                                        <BsPlay style={{ fontSize: "1.5rem", color: "green" }} />
                                    </Box>
                                </Box>
                            </Box>
                        </GridItem>

                        <GridItem w='100%' >
                            <Box className='box-style-card'>
                                <Box p={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">
                                                Scheduled
                                            </Text>
                                            <Text fontSize="2xl" fontWeight="semibold">
                                                {stats?.scheduled || 0}
                                            </Text>
                                        </Box>
                                        <BsCalendar style={{ fontSize: "1.5rem", color: "blue" }} />
                                    </Box>
                                </Box>
                            </Box>
                        </GridItem>

                        <GridItem w='100%' >
                            <Box className='box-style-card'>
                                <Box p={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">
                                                Completed
                                            </Text>
                                            <Text fontSize="2xl" fontWeight="semibold">
                                                {stats?.completed || 0}
                                            </Text>
                                        </Box>
                                        <FaCheck style={{ fontSize: "1.5rem", color: "green" }} />
                                    </Box>
                                </Box>
                            </Box>
                        </GridItem>

                        {/* <GridItem w='100%' >
                            <Box className='box-style-card'>
                                <Box p={1}>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Box>
                                            <Text fontSize="sm" color="gray.500">
                                                Delivery Rate
                                            </Text>
                                            <Text fontSize="2xl" fontWeight="semibold">
                                                {stats?.deliveryRate || '0%'}
                                            </Text>
                                        </Box>
                                        <IoTrendingUpOutline style={{ fontSize: "1.5rem", color: "blue" }} />
                                    </Box>
                                </Box>
                            </Box>
                        </GridItem> */}
                    </Grid>
                )}


                <Box style={{ width: "100%" ,marginTop:"1rem"}}>
                    <CampaignManagementTable handleNewCampaign={handleNewCampaign} />
                </Box>
            </BoxWrapper>
        </>
    )
}

export default Campaign